function debounce(func, delay) {
    let timeout;

    return function executedFunc(...args) {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            func(...args);
            timeout = null;
        }, delay);
    };
}

$(function() {
    const form = {
        init() {
            form.create();
            form.password();
            form.search();
            form.renderRecentSearch();
            form.selectPhone();
            form.payroll();
        },
        create() {

        },
        selectPhone() {
            const phoneEle = $('.ginput_container_phone select');
            if (phoneEle.length == 0) return;

            var w = 0;

            phoneEle.change(function(event) {
                if($(this).val() > 999) {
                    w = 60;
                } else if($(this).val() > 99) {
                    w = 53;
                } else {
                    w = 46;
                }

                $(this).outerWidth(w);
            });
        },
        password() {
            const eyeElement = $('[data-eye-element]');

            if (eyeElement.length == 0) return;

            $('body').on('click', '[data-eye-element]', function(event) {
                event.preventDefault();
                if ($(this).hasClass('on')) {
                    $(this).removeClass('on');
                    $(this).parent().find('.form-control').attr('type', 'password');
                } else {
                    $(this).addClass('on');
                    $(this).parent().find('.form-control').attr('type', 'text');
                }
            });

        },
        renderRecentSearch() {
            const recentSearch = $('[data-recent-search]');
            if (recentSearch.length) {
                let html = '';
                const lang = $('html')[0].lang;
                const keySearchByLang = lang === 'en-US' ? 'RECENT_SEARCH' : 'RECENT_SEARCH_VI';
                const cacheRecentSearch = localStorage.getItem(keySearchByLang);
                if (cacheRecentSearch) {
                    const keywords = cacheRecentSearch.split(',').filter(item => item);
                    for (var i = 0; i < keywords?.length; i++) {
                        html += `<li>
                            <a href="${window.location.origin}?s=${keywords[i]}" title="${keywords[i]}" target="_blank">${keywords[i]}</a>
                        </li>`;
                    }
                }

                if (html) {
                    recentSearch.find('ul').html(html);
                    recentSearch.stop().fadeIn();
                } else {
                    recentSearch.stop().fadeOut();
                }
            }
        },
        search() {
            const searchTerm = $('[data-search-term]');
            if (searchTerm.length == 0) return;

            const eventHandler = (event) => {
                const eleResults = $('[data-search-term-result]');
                const lang = $('html')[0].lang;
                const keySearchByLang = lang === 'en-US' ? 'RECENT_SEARCH' : 'RECENT_SEARCH_VI';
                let cacheRecentSearch = localStorage.getItem(keySearchByLang) || '';

                if (event?.target?.value != '') {
                    // Moengage: SearchClick
                    Moengage.track_event('SearchClick', {
                        Keyword: event?.target?.value.replace(/\n|\r|\t/g, '')
                    });

                    searchTerm.closest('form').addClass('w-loading');
                    $.ajax({
                        url: talentnet?.ajax_url,
                        // url: 'https://tln.bluecoral.vn/wp-admin/admin-ajax.php',
                        type: "POST",
                        dataType: "json",
                        data: {
                            action: "get_search",
                            number: 10,
                            text: event?.target?.value
                        },
                        success: function (res) {
                            if (res.success) {
                                const emptyMsg = $('[data-search-term-result]').data('empty-msg');
                                eleResults.addClass('on');

                                let html = '';
                                if (res?.data?.length) {
                                    for (var i = 0; i < res?.data?.length; i++) {
                                        html += `<li id="${res?.data[i]?.ID}">
                                            <a href="${res?.data[i]?.post_url}">${res?.data[i]?.post_title}</a>
                                        </li>`;
                                    }
                                } else {
                                    html += `<li>${emptyMsg}</li>`;
                                }

                                eleResults.find('ul').html(html);
                            }

                            searchTerm.closest('form').removeClass('w-loading');

                            if (event?.target?.value) {
                                cacheRecentSearch = cacheRecentSearch ? `${cacheRecentSearch},${event?.target?.value}` : event?.target?.value;

                                const ks = cacheRecentSearch?.split(',') || [];
                                if (cacheRecentSearch?.split(',').length > 5) {
                                    ks.splice(0, cacheRecentSearch?.split(',').length - 5);
                                }

                                localStorage.setItem(keySearchByLang, ks.join(','));

                                form.renderRecentSearch();
                            }
                        },
                    });
                } else {
                    eleResults.removeClass('on');
                }

            };
            const dHandler = debounce(eventHandler, 350);

            searchTerm.on('input', dHandler);

            // search page
            $('[data-search-input]').on('input', function() {
                if (this.value !== '') {
                    $(this).parents('.form-group').addClass('is-value');
                } else {
                    $(this).parents('.form-group').removeClass('is-value');
                }
            });

            $('.cta-reset').on('click', function(event) {
                event.preventDefault();

                const searchInput = $(this).parents('.form-group').find('[data-search-input]');
                searchInput.val('');
                $(this).parents('.form-group').removeClass('is-value');
            });

            $('[data-search-input]').each(function() {
                const value = $(this).val();
                if (value !== '') {
                    $(this).parents('.form-group').addClass('is-value');

                    var keyword = $(this).val();

                    $('[data-item-title]').each(function() {
                        var text = $(this).text();
                        var highlightedText = text.replace(new RegExp(keyword, "gi"), "<mark>$&</mark>");
                        $(this).html(highlightedText);
                    });

                    $('[data-item-description] p').each(function() {
                        var text = $(this).text();
                        var highlightedText = text.replace(new RegExp(keyword, "gi"), "<mark>$&</mark>");
                        $(this).html(highlightedText);
                    });
                }
            });
        },
        payroll() {
            const payrollForm = $('[data-payroll]');
            if (!payrollForm.length) return;

            function objectifyForm(formArray) {
                var returnArray = {};
                for (var i = 0; i < formArray.length; i++){
                    returnArray[formArray[i]['name']] = formArray[i]['value'];
                }
                return returnArray;
            }

            const obtMap = payrollForm.data('map-products') ? payrollForm.data('map-products') : {};

            payrollForm.validate({
                rules: {
                    "employee_count": {
                        required: true,
                    },
                    "product": {
                        required: true,
                    },
                },
                messages: {
                    "employee_count": {
                        required: payrollForm.data('msg-required'),
                    },
                    "product": {
                        required: payrollForm.data('msg-required'),
                    },
                }
            });

            payrollForm.on('submit', function(e) {
                e.preventDefault();
                const self = $(this);
                const targetBlock = $(`${self.data('target')}`);
                const {
                    employee_count,
                    product
                } = objectifyForm(self.serializeArray()) || {};

                const countInt = parseInt(employee_count);
                let key = '';
                if (countInt < 500) {
                    key = 'less_than_500';
                } else if (countInt >= 500 & countInt <= 1000) {
                    key = 'between_500_1000';
                } else if (countInt > 1000) {
                    key = 'more_than_1000';
                }

                const subProducts = product && key ? obtMap[product][key] : [];

                if (subProducts.length) {
                    let htmlProducts = '';
                    targetBlock.find('[data-expandable-product]').each(function() {
                        const self = $(this);
                        const ep = self.data('expandable-product');
                        if ((`${ep}`.length && subProducts.includes(parseInt(ep)))) {
                            htmlProducts += `<div class="solution-box">
                                <h3>
                                    <a href="${self.find('.link').first().attr('href') || ''}" title="${self.data('title')}">${self.data('title')}</a>
                                </h3>
                                <div class="copy w-default">
                                    ${self.data('description')}
                                </div>
                            </div>`;
                        }
                    });

                    if (htmlProducts) {
                        payrollForm.closest('.panel-calculator').find('.solution .solution-list').html(htmlProducts || `<p>Not Found</p>`);
                    }

                    payrollForm.closest('.panel-calculator').find('.solution').stop().fadeIn();
                }
            })
        }
    };

    form.init();
});